const UTILS = require("../libs/utils.js");
const config = require("../config.js");
function Pet(p12419, p12420) {
  this.init = function (p12421, p12422) {
    this.active = true;
    this.owner = p12421;
    this.preview = p12422;
    var v9875 = this.getTPos();
    this.x = v9875.x;
    this.y = v9875.y;
    this.z = v9875.z;
    this.xRot = 0;
    this.speed = 0.12;
    this.scale = 0.8;
    this.bobSpd = 0.002;
    this.bobY = 0;
    if (p12420 && (this.mesh = p12420.genObj3D(0, 0, 0), p12421.petIndex >= 0)) {
      var v9876 = p12419.store.skins[p12421.petIndex];
      this.speed = v9876.spd || this.speed;
      this.scale = v9876.sclMlt || this.scale;
      p12420[v9876.hasAnim ? "loadAnimMesh" : "loadMesh"]({
        fileExt: v9876.fileExt,
        animS: v9876.animS,
        hasAnim: v9876.hasAnim,
        local: v9876.local,
        localM: v9876.localM,
        src: "pets/pet_" + v9876.id,
        texSrc: v9876.tex ? "pets/pet_" + v9876.id + "_" + v9876.tex : null,
        frames: v9876.frames,
        frameT: v9876.frameT,
        rotT: v9876.rotT,
        movT: v9876.movT,
        movD: v9876.movD,
        sameEnv: v9876.sameEnv,
        env: v9876.env || v9876.sameEnv ? v9876.env || 3 : undefined,
        sameGlow: v9876.sameGlow,
        glowText: v9876.glow,
        emissive: v9876.glow || v9876.sameGlow ? v9876.emiss || "#ffffff" : null,
        pulsT: v9876.pulsT,
        transparent: v9876.opac != null || v9876.trans,
        rAnim: v9876.rAnim,
        rAnimA: v9876.rAnimA,
        rAnimT: v9876.rAnimT,
        rAnimM: v9876.rAnimM,
        rgb: v9876.rgb,
        rgbS: v9876.rgbS,
        rgbT: v9876.rgbT,
        useWireframe: v9876.wire,
        side: v9876.side || 0,
        opacity: v9876.opac || 1,
        alphaTest: v9876.alpha || 0,
        shaderNum: v9876.shaderNum,
        video: v9876.video,
        projection: v9876.projection,
        color: v9876.color || null
      }, 0, 0, 0, this.preview ? 0 : Math.PI / 2, this.scale, this.mesh);
      if (this.preview) {
        this.owner.objInstances.parent.add(this.mesh);
      } else {
        p12420.scene.add(this.mesh);
      }
    }
  };
  let v9877 = p12420 ? new p12420.THREE.Vector3() : null;
  this.getTPos = function () {
    return this.owner.petHolder.getWorldPosition(v9877);
  };
  this.update = function (delta) {
    if (this.active) {
      var v9878 = this.getTPos();
      var v9879 = UTILS.getDrs(v9878, this);
      var v9880 = (v9879[0] || 0) + Math.PI / 2;
      var v9881 = v9879[1] || 0;
      var v9882 = UTILS.getD3D(this.x, this.y, this.z, v9878.x, v9878.y, v9878.z);
      var v9883 = Math.min(v9882, this.speed * delta);
      var vLN1143 = 1;
      if (v9882 < 40) {
        vLN1143 = v9882 / 40;
      }
      v9883 *= vLN1143;
      this.x += v9883 * Math.sin(v9880 + Math.PI / 2) * Math.cos(v9881);
      this.z += v9883 * Math.cos(v9880 + Math.PI / 2) * Math.cos(v9881);
      this.y += v9883 * Math.sin(v9881);
      if (this.mesh) {
        this.bobY += this.bobSpd * delta;
        this.mesh.position.set(this.x, this.y + Math.sin(this.bobY) * 0.2, this.z);
        v9880 -= Math.PI / 2;
        var v9884 = Math.PI * 2;
        var v9885 = (this.mesh.rotation.y - v9880 + v9884) % v9884;
        var v9886 = Math.min(Math.abs(v9885 - v9884), v9885, vLN1143 * 0.01 * delta);
        var v9887 = v9885 - Math.PI >= 0 ? 1 : -1;
        this.mesh.rotation.y += v9887 * v9886 + v9884;
        this.mesh.rotation.y %= Math.PI * 2;
      }
    }
  };
}
module.exports = function (p12424, p12425, p12426) {
  this.list = [];
  this.update = function (delta) {
    for (var vLN01587 = 0; vLN01587 < this.list.length; ++vLN01587) {
      this.list[vLN01587].update(delta);
    }
  };
  this.add = function (p12428, p12429) {
    if (!(p12428.petIndex < 0)) {
      var v9888 = new Pet(p12424, p12425, p12426);
      v9888.init(p12428, p12429);
      this.list.push(v9888);
    }
  };
  this.remove = function (p12430) {
    if (!(p12430.petIndex < 0)) {
      for (var v9889 = this.list.length - 1; v9889 >= 0; --v9889) {
        if (this.list[v9889] && this.list[v9889].owner == p12430) {
          if (this.list[v9889].mesh) {
            if (this.list[v9889].preview) {
              this.list[v9889].owner.objInstances.parent.remove(this.list[v9889].mesh);
            } else {
              p12425.scene.remove(this.list[v9889].mesh);
            }
          }
          this.list.splice(v9889, 1);
          break;
        }
      }
    }
  };
};